import React from 'react'
import { withTranslation } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { Icon } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone } from '@fortawesome/free-solid-svg-icons';

const DisplaysDetailList = ({ detailsDisplays, icons = false, i18n }) => {
  const { t } = useTranslation();
  return (
    <>
    {
      detailsDisplays.totalIndividualDisplays > 0 && (
        <span style={{display: "block", marginBottom: "5px"}}>
            {icons && (
            <Icon
                type="desktop"
                theme="outlined"
                style={{ marginRight: "12px" }}
            />
            )}
            <strong>{detailsDisplays.totalIndividualDisplays}</strong> {" "}
            {detailsDisplays.totalIndividualDisplays === 1 ? t("individual screen") : t("individual screens")} {t("added")}
            {(i18n.language == "es" || i18n.language == "es_ar" ) && detailsDisplays.totalIndividualDisplays > 1
                ? "s"
                : ""}{" "}
        </span>
    )
  }
  {
    detailsDisplays.totalCircuits > 0 && (
    <div>
      <span style={{display: "block", marginBottom: "5px"}}>
        {icons && (
        <Icon
            type="deployment-unit"
            theme="outlined"
            style={{ marginRight: "12px" }}
        />
        )}
        <strong>{detailsDisplays.totalCircuits}</strong> {" "}
        {detailsDisplays.totalCircuits === 1 ? t("circuit added") : t("circuits added")}
        {" "}
        ({detailsDisplays.totalCircuitsDisplays} {t("screens")}{detailsDisplays.totalCircuits > 1 ? ` ${t("in total")}` : ""})
      </span>
      {
        detailsDisplays.totalDisplaysWithMultipleFacesInCircuits > 0 && (
            <ul style={{marginBottom: "5px"}}>
                <li><strong>{detailsDisplays.totalCircuitsDisplays - detailsDisplays.totalDisplaysWithMultipleFacesInCircuits}</strong> {t("individual screens")}</li>
                <li>
                    <strong>{detailsDisplays.totalDisplaysWithMultipleFacesInCircuits}</strong> {" "}
                    {detailsDisplays.totalMultipleFacesDisplays === 1 ? t("multiple face screen") : t("multiple face screens")}
                    {detailsDisplays.totalMultipleFacesInCircuits > 1 ? ` (${detailsDisplays.totalMultipleFacesInCircuits} ${t("faces")} ${t("in total")})` : ""}
                </li>
            </ul>
        )
      }
    </div>
    )
  }
  {
    detailsDisplays.totalMultipleFacesDisplays > 0 && (
      <span style={{display: "block", marginBottom: "5px"}}>
        {icons && (
        <FontAwesomeIcon
            icon={faClone}
            size="1x"
            style={{ marginRight: "12px" }}
        />
        )}
        <strong>{detailsDisplays.totalMultipleFacesDisplays}</strong> {" "}
        {detailsDisplays.totalMultipleFacesDisplays === 1 ? t("multiple face screen") : t("multiple face screens")} {t("added")}
        {(i18n.language == "es" || i18n.language == "es_ar" ) && detailsDisplays.totalMultipleFacesDisplays > 1
            ? "s"
            : ""}{" "}
        {" "}
        ({detailsDisplays.totalMultipleFaces} {t("faces")}{detailsDisplays.totalMultipleFacesDisplays > 1 ? ` ${t("in total")}` : ""})
      </span>
    )
  }
  </>
  )
}

const Extended = withTranslation()(DisplaysDetailList);
Extended.static = DisplaysDetailList.static;

export default withRouter(Extended);